import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Tooltip, Typography } from "@mui/material";

import {
  STOCK_COUNT_STATUS,
  STOCK_COUNT_STATUS_LABELS,
} from "../utils/stockCountModel";

const STATUS_STYLES = {
  [STOCK_COUNT_STATUS.PENDING]: {
    bgcolor: "rgba(233, 165, 35, 0.16)",
    color: "rgba(142, 91, 0, 1)",
  },
  [STOCK_COUNT_STATUS.IN_PROGRESS]: {
    bgcolor: "rgba(47, 128, 237, 0.16)",
    color: "rgba(24, 86, 170, 1)",
  },
  [STOCK_COUNT_STATUS.REALIZED]: {
    bgcolor: "rgba(111, 66, 193, 0.16)",
    color: "rgba(76, 40, 133, 1)",
  },
  [STOCK_COUNT_STATUS.APPROVED]: {
    bgcolor: "rgba(33, 150, 83, 0.16)",
    color: "rgba(18, 111, 63, 1)",
  },
  [STOCK_COUNT_STATUS.CANCELLED]: {
    bgcolor: "rgba(117, 117, 138, 0.18)",
    color: "rgba(74, 74, 92, 1)",
  },
  [STOCK_COUNT_STATUS.EXPIRED]: {
    bgcolor: "rgba(195, 60, 60, 0.16)",
    color: "rgba(160, 49, 49, 1)",
  },
};

export default function StockCountStatusPill({ status, description = "" }) {
  const styles = STATUS_STYLES[status] || {
    bgcolor: "rgba(117, 117, 138, 0.18)",
    color: "rgba(74, 74, 92, 1)",
  };

  return (
    <Box
      sx={{
        px: 1.2,
        py: 0.35,
        borderRadius: "16px",
        bgcolor: styles.bgcolor,
        boxShadow: "inset 0px 0px 2px rgba(142, 142, 159, 0.18)",
        whiteSpace: "nowrap",
        display: "inline-flex",
        alignItems: "center",
        gap: 0.25,
      }}
    >
      <Typography
        component="span"
        sx={{
          color: styles.color,
          fontSize: 11,
          fontWeight: 800,
          textAlign: "center",
          lineHeight: 1.3,
        }}
      >
        {STOCK_COUNT_STATUS_LABELS[status] || status || "—"}
      </Typography>
      {description ? (
        <Tooltip title={description} arrow placement="top">
          <Box
            component="span"
            tabIndex={0}
            aria-label={description}
            sx={{
              width: 14,
              height: 14,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              color: styles.color,
              cursor: "help",
              "& svg": {
                fontSize: 14,
              },
            }}
          >
            <InfoOutlinedIcon />
          </Box>
        </Tooltip>
      ) : null}
    </Box>
  );
}
